import React from 'react'
import { Route } from 'react-router-dom'
import useModuleRoutes from 'utils/hooks/useModuleRoutes'

const Finance = () => {
  const subRoutes = useModuleRoutes('finance')

  return subRoutes.map((route) => (
    <Route path={route.path} key={'route-' + route.key} {...route} />
  ))
}

export default Finance
